import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {getter, immediate}
    } = publicMethodUtils

    return {
        methods: {
            editorFeatures: {
                instances: {
                    list: getter('editorFeatures.instances.list'),
                    create: immediate('editorFeatures.instances.create')
                },
                data: {
                    getPointer: getter('editorFeatures.data.getPointer'),
                    list: getter('editorFeatures.data.list'),
                    get: getter('editorFeatures.data.get'),
                    remove: immediate('editorFeatures.data.remove'),
                    update: immediate('editorFeatures.data.update')
                }
            }
        }
    }
}
